import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Select from 'react-select';
import DarkSelectStyles from '../SelectBoxStyles/SelectBoxStyles';
import Api from '../../../services/ApiService';
import './ActiveFiltersDropdown.scss';

const ActiveFiltersDropdown = ({ endpoint }) => {
  const typeOptions = [
    { value: 'all', label: 'All' },
    { value: { is_active: true, is_admin: true }, label: 'Admin'},
    { value: { is_active: true, is_admin: false }, label: 'User'},
    { value: { is_active: false, is_admin: false }, label: 'Inactive'},
  ];
  const [type, setType] = useState(typeOptions[0]);

  return (
    <div className="dropdown-wrapper" style={{ width: '100%' }}>
      <Select
        options={typeOptions}
        value={type}
        onChange={(selected) => {
          setType(selected);
          selected.value !== 'all'
            ? Api.get(`${endpoint}${selected.value.is_admin ? '?is_admin=1' : `?is_active=${selected.value.is_active ? 1 : 0}`}`)
            : Api.get(`${endpoint}`);
        }}
        styles={DarkSelectStyles}
      />
    </div>
  );
};

ActiveFiltersDropdown.propTypes = {
  endpoint: PropTypes.string.isRequired,
};

export default ActiveFiltersDropdown;
